import { classnames } from 'tailwindcss-classnames';

const QuoteUp = (): JSX.Element => (
  <div className={classnames('absolute', 'right-0', 'top-0')}>
    <div className={classnames('svg-sm')}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="74"
        height="157"
        viewBox="0 0 74 157"
        fill="none"
      >
        <path
          d="M115 22.8238C115 -22.954 86.4483 -49 53.931 -49C23.7931 -49 8.24068e-06 -24.5325 5.68767e-06 4.67051C3.13466e-06 33.8736 20.6207 54.3947 46.7931 54.3947C52.3448 54.3947 58.6897 53.6053 60.2759 52.8161C55.5172 79.6514 28.5517 112.011 3.17242 127.008L41.2414 157C84.862 126.218 115 77.2835 115 22.8238Z"
          fill="url(#paint0_linear_3662_1487)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3662_1487"
            x1="115"
            y1="53.5381"
            x2="-3.85603e-06"
            y2="53.5381"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="var(--color-blue)" />
            <stop offset="0.942708" stopColor="var(--color-dayglow)" />
          </linearGradient>
        </defs>
      </svg>
    </div>
    <div className={classnames('svg-lg')}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="103"
        height="210"
        viewBox="0 0 103 210"
        fill="none"
      >
        <path
          d="M173 6.78163C173 -62.5517 130.048 -102 81.1311 -102C35.7931 -102 2.40362e-05 -64.9425 2.01695e-05 -20.7126C1.63028e-05 23.5172 31.0207 54.5977 70.3931 54.5977C78.7448 54.5977 88.2897 53.4023 90.6759 52.2069C83.5172 92.8506 42.9517 141.862 4.77243 164.575L62.0414 210C127.662 163.379 173 89.2644 173 6.78163Z"
          fill="url(#paint0_linear_3662_13449)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3662_13449"
            x1="173"
            y1="53.3005"
            x2="1.72461e-05"
            y2="53.3004"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="var(--color-blue)" />
            <stop offset="0.942708" stopColor="var(--color-dayglow)" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  </div>
);

export default QuoteUp;
